import React from 'react';
import ellipse from '../Assets/about/patten.png';
import img from '../Assets/about/factory1.jpeg';
import pattern from '../Assets/about/bg-pattern.png';
import { motion } from 'framer-motion';
import { Card } from "flowbite-react";
import imgSrc from '../Assets/about/factory1.jpeg';
import imgSrc2 from '../Assets/about/factory2.jpg';
import Countup from 'react-countup';
import { useInView } from 'react-intersection-observer';

import MacBookAir from "./MacBookAir";
import Map from "./Mapreview";

const About = () => {
    const { ref: countUpRef, inView: countUpIsVisible } = useInView({
        triggerOnce: true, // Only trigger once
        threshold: 0.3, // Trigger when 30% of the element is visible
    });
    const { ref: countUpRef2, inView: countUpIsVisible2 } = useInView({
        triggerOnce: true, // Only trigger once
        threshold: 0.2, // Trigger when 30% of the element is visible
    });

    return (
        <>
            <section className="min-h-screen lg:min-h-screen flex items-center bg-about2 bg-cover bg-no-repeat bg-center "
                loading="lazy" >
                {/* <div className='container mx-auto text-left font-primary lg:pl-24 sm:text-[20px] md:text-[35px] lg:text-[43px] text-gray-800'>
                    <h2 className="leading-normal sm:text-[55px] md:text-[75px] text-gradient-light">About US</h2>
                    <p className="m-0 leading-loose">
                        <span className="text-gray-800">{`" There is no sincerer `}</span>
                        <span className='text-accent2-300'>love</span>
                        <span className="whitespace-pre-wrap">{` `}</span>
                    </p>
                    <p className="m-0 leading-loose">
                        <span className="whitespace-pre-wrap">{`                                than the `}</span>
                        <span className='text-accent2-300'>love</span>
                        <span className="text-gray-800"> of food "</span>
                    </p>
                </div> */}
            </section>

            <section className='min-h-[100vh] lg:min-h-[100vh] flex justify-center items-center '>
                <div className="relative font-secondary">
                    <div className="px-4 mx-auto max-w-7xl sm:px-6 sm:py-6">
                        <div className="grid max-w-lg grid-cols-1 mx-auto lg:max-w-full lg:grid-cols-2 gap-y-12 lg:gap-x-8 items-center">
                            <div className="relative lg:flex lg:flex-col lg:items-start lg:justify-center">
                                <div className="absolute bottom-0 left-0 overflow-hidden lg:inset-y-0">
                                    <img className="w-auto h-full" src={pattern} alt="" />
                                </div>
                                <div className="text-center lg:text-left">
                                    <h1 className="text-4xl font-bold leading-tight text-gray-900 sm:text-5xl sm:leading-tight lg:leading-tight lg:text-6xl font-pj text-shadow-xl">
                                        THE JOURNEY OF ARYAA FOODS
                                    </h1>
                                    <h3 className="mt-2 text-xl text-gray-600 sm:mt-8">
                                        Since 2011, Aryaa Foods Has Been Dedicated To Providing The UAE With Delicious.
                                    </h3>
                                    <p className="mt-2 text-lg text-gray-600 sm:mt-8">
                                        Ready-To-Cook South Indian Meals, Making Home-Cooked Flavors Accessible And Convenient. From Our Carefully Selected Raw Materials To Our Meticulous Preparation Process, Every Product From Aryaa Foods Is A Testament To Our Commitment To Excellence And Authenticity.
                                    </p>
                                </div>
                                <div ref={countUpRef2} className="flex items-center justify-center mt-10 space-x-6 lg:justify-start sm:space-x-8">
                                    <div className="flex items-center">
                                        <p className="text-3xl font-medium text-gray-900 sm:text-4xl">{countUpIsVisible2 && <Countup start={0} end={20} duration={4} />}+</p>
                                        
                                        <p className="ml-3 text-sm text-gray-900">Quality<br />Checks</p>
                                    </div>
                                    <div className="hidden sm:block">
                                        <svg className="text-gray-400" width="16" height="39" viewBox="0 0 16 39" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <line x1="0.72265" y1="10.584" x2="15.7226" y2="0.583975"></line>
                                            <line x1="0.72265" y1="17.584" x2="15.7226" y2="7.58398"></line>
                                            <line x1="0.72265" y1="24.584" x2="15.7226" y2="14.584"></line>
                                            <line x1="0.72265" y1="31.584" x2="15.7226" y2="21.584"></line>
                                            <line x1="0.72265" y1="38.584" x2="15.7226" y2="28.584"></line>
                                        </svg>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="text-3xl font-medium text-gray-900 sm:text-4xl">{countUpIsVisible2 && <Countup start={0} end={20} duration={4} />}</p>
                                        <p className="ml-3 text-sm text-gray-900">Years of<br />Experience</p>
                                    </div>
                                </div>
                            </div>
                            <div className="relative max-w-full mx-auto lg:ml-auto lg:max-w-[800px]">
                                {/* <img src={imgSrc2} alt="" /> */}
                                <img className="w-full" src={ellipse} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='min-h-[100vh] lg:min-h-[100vh] flex items-center bg-aboutc bg-cover bg-no-repeat bg-center bg-about3'>
                <div className='container py-6 mx-auto px-0'>
                    <div className='pb-6'>
                        <h2 className='uppercase font-primary text-[50px] leading-10 text-shadow-xl'>
                            OUR <span className='text-accent'>VISION <span className='text-text'> & </span>MISSION</span>
                        </h2>
                        <h3 className='capitalize leading-8 font-primary sm:text-[25px] md:text-[35px] pt-5 text-gray-200'>We give best quality food to our customer</h3>
                    </div>
                    <div className='flex flex-col gap-y-5 lg:flex-row lg:items-center lg:gap-y-0 '>

                        <div className='flex flex-1 justify-center items-center'>
                            <Card
                                className="max-w-md text-left min-h-[450px] leading-normal glass-effect"
                            >
                                <span className='sm:pb-1 lg:pb-2'>
                                    <h5 className="text-[30px] text-shadow-xl font-bold  text-accent dark:text-white pb-0 lg:pb-3 ">
                                        VISION
                                    </h5>
                                    <p className="font-normal text-gray-700 dark:text-gray-400 text-[18px]" >
                                        To be the preferred choice for authentic South Indian cuisine globally, by consistently delivering products that exceed our customers' expectations in taste, quality, and convenience.
                                    </p>
                                </span>

                                <span className='sm:pb-1 lg:pb-2'>
                                    <h5 className="text-[30px] text-shadow-xl font-bold dark:text-white text-accent pb-3">
                                        MISSION
                                    </h5>

                                    <ul className='font-normal text-gray-700 dark:text-gray-400 text-[17px]'>
                                        <li>
                                            We strive to meet and exceed our customer’s expectations by:
                                        </li>
                                        <li>
                                            Using the highest quality ingredients.
                                        </li>
                                        <li>
                                            Ensuring the freshness and authenticity of our products.
                                        </li>
                                        <li>
                                            Continuously improving our processes and offerings.
                                        </li>
                                    </ul>

                                </span>
                            </Card>
                        </div>

                        <div className='flex flex-1 justify-center items-center'>
                            <Card
                                className="max-w-md text-left min-h-[450px] glass-effect "
                            >
                                <span className='pb-2 leading-normal'>
                                    <h5 className="text-[28px] font-bold text-shadow-xl tracking-tight dark:text-white text-accent pb-3">
                                        The Achievements of ARYAA Foods
                                    </h5>
                                    <p className="font-normal text-gray-700 dark:text-gray-400 text-[17px]">
                                        How travel can be one of the best tools for personal growth. We share some of the life lessons we've learned on the road that has provided us insight into empathy, mindfulness, meditation, comfort zones, two-way storytelling, being present, connection and more.
                                    </p>
                                </span>                            <span className='pb-2 text-center text-gray-800'>
                                <div ref={countUpRef} className='flex flex-wrap gap-x-6 lg:gap-x-10 md:gap-x-6 sm:gap-x-2 mb-5 justify-center'>
                                    <div className='glass-effect border-2 border-black rounded px-7 py-3'>
                                        <div className='text-[40px] lg:text-[40px] md:text-[35px] sm:text-[30px] font-tertiary text-gradient mb-2'>
                                            {countUpIsVisible && <Countup start={0} end={100} duration={4} />}+
                                        </div>
                                        <div className='font-primary text-sm tracking-[2px]'>USERS</div>
                                    </div>
                                    <div className='glass-effect border-2 border-black rounded px-7 py-3'>
                                        <div className='text-[40px] lg:text-[40px] md:text-[35px] sm:text-[30px] font-tertiary text-gradient mb-2'>
                                            {countUpIsVisible && <Countup start={0} end={100} duration={4} />}+
                                        </div>
                                        <div className='font-primary text-sm tracking-[2px]'>STORES</div>
                                    </div>
                                </div>

                                <div className='flex flex-wrap gap-x-4 mt-5 lg:gap-x-14 md:gap-x-10 sm:gap-x-2 mb-2 justify-center'>
                                    <div className='glass-effect border-2 border-black rounded px-5 py-3'>
                                        <div className='text-[30px] lg:text-[30px] md:text-[25px] sm:text-[20px] font-tertiary text-gradient mb-2'>
                                            {countUpIsVisible && <Countup start={0} end={50} duration={4} />}+
                                        </div>
                                        <div className='font-primary text-sm tracking-[2px]'>Food Shop</div>
                                    </div>
                                    <div className='glass-effect border-2 border-black rounded px-5 py-3'>
                                        <div className='text-[30px] lg:text-[30px] md:text-[25px] sm:text-[20px] font-tertiary text-gradient mb-2'>
                                            {countUpIsVisible && <Countup start={0} end={3} duration={4} />}+
                                        </div>
                                        <div className='font-primary text-sm tracking-[2px]'>Countries</div>
                                    </div>
                                </div>
                            </span>
                        </Card>
                    </div>

                </div>
            </div>
        </section>

        <section className='min-h-[100vh] lg:min-h-[100vh]  p-2 font-secondary'>
            <h2 className='font1 text-[40px] mb-2 text-accent text-shadow-md'>What Our Customer Say About Us</h2>
            <p className='text-gray-400 text-[20px]'>What customers says about our Foots and Mixes. Customers compliment is most important to upgradation of bussiness service </p>
            <div className='w-full h-full bg-no-repeat bg-center bg-mapbg'>
                <Map />
            </div>
        </section>
    </>
)
}

export default About
